module.exports = __webpack_public_path__ + "h5/img/head4.e59ade8b.png";